import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import BREAKPOINTS from '@mlb/react-patterns/v4/style/breakpoints';
import { cardTypes } from 'bdata-sns-shared/utils/productButtonConfigs';

const {
    mlbGrey5
} = COLORS;

// dynamic height shorter for playoffs since there is extra UI in status bar
export const PlayerMatchupLayerWrapper = styled.div`
    height: ${({ isPostSeason, mode }) => isPostSeason && mode !== cardTypes.MIG
        ? (mode !== cardTypes.MINI_SB
            ? '80px'
            : '60px')
        : mode === cardTypes.MIG
            ? 'auto'
            : '100px'
    };
    margin-top: ${({ isPostSeason, mode }) => isPostSeason ? (mode !== cardTypes.MINI_SB ? '0' : '4px') : '0'};
    
    @media (max-width: ${BREAKPOINTS.sm}) {
        flex: 1;
        height: auto;
    }
`;

export const PlayerMatchupHeaderWrapper = styled.div`
    font-size: 11px;
    font-weight: bold;
    color: ${mlbGrey5};
    display: flex;
    justify-content: space-between;
    text-transform: uppercase;
`;

export const PlayerMatchupTeamWrapper = (
    styled.div`
        font-weight: 600;
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        ${({ mode }) => mode === cardTypes.MINI_SB
        ? `
                &:first-child {
                    padding-right: 3px;
                }
            `
        : ''
    }
    `
);

export const PlayerMatchupContentWrapper = styled.div`
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    @media (max-width: ${BREAKPOINTS.sm}) {
        transform: none;
    }
`;

export const TeamLiveWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: ${({ inline }) => (inline) ? '100%' : '50%'};

    > div:first-child {
        margin-left: 0;
        margin-right: 3px;
    }
`;

export const PlayerMatchupWrapper = (
    styled.div`
        display: ${({ useStackedLayout }) => (useStackedLayout) ? 'block' : 'flex'};
        flex-wrap: ${({ useStackedLayout }) => (useStackedLayout) ? 'nowrap' : 'wrap'};

        > a, > div {
            width: ${({ useStackedLayout }) => (useStackedLayout) ? '100%' : '50%'};
            margin: 5px 0;
        }

        div, span {
           font-size: ${({ mode }) => mode === cardTypes.MINI_SB ? '11px' : '13px'};
        }   
    `
);

// space between bottom of stats and next section on mobile should ~match space between
// bottom of linescore and the due up label
export const DueUpMatchupWrapper = styled(PlayerMatchupWrapper)`
    flex-direction: row;
    > a, > div {
        margin: 0;
        width: 33%;
        margin-top: 5px;

        @media (max-width: 350px) {
            > div {
                > div:last-child {
                    > div:last-child {
                        display: none;
                    }
                }
            }
        }
    }
`;
